<div class="d-flex" id="wrapper">
    <admin-sidebar></admin-sidebar>

    <div id="page-content-wrapper">

        <admin-navigation></admin-navigation>

        <div class="container-fluid">
            <div class="d-flex mt-5 mb-5">
                <h3 class="font-weight-bold page-title mr-auto">Audio Pods</h3>
                <button [routerLink]="['/resources/audio-pods/create/new']" type="button" class="btn btn-primary pull-right add-button">Add Resource</button>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <p class="font-weight-bold">Total: {{ resources?.length }}</p>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12 table-responsive">
                  <table class="table table-borderless">
                    <thead>
                    <tr>
                      <th class="text-left">Title</th>
                      <th class="text-left">Points</th>
                      <th class="text-left">Is Free</th>
                      <th class="text-left">Duration</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let data of resources" [routerLink]="['/resources/audio-pods', data.id]">
                        <td>{{ data.title }}</td>
                        <td>{{ data.points }}</td>
                        <td>{{ (data.is_free === 1) ? 'Yes' : 'No' }}</td>
                        <td>{{ data.duration }}</td>
                    </tr>
                    <tr *ngIf="resources?.length === 0">
                      <td class="align-middle text-center" colspan="4">No Record Found</td>
                    </tr>
                    </tbody>
                  </table>
        
                </div>
              </div>
        </div>

        <!-- Modal Loader -->
        <modal-loader [modalText]="modalText"></modal-loader>

    </div>
</div>